export const messages = {
  errorTitle: {
    id: 'authoring.texteditor.selectimagemodal.error.errorTitle',
    defaultMessage: 'Error',
    description: 'Title of message presented to user when something goes wrong',
  },
};

export default messages;
